import React from 'react';
function LoadingMessage(props) {
    const { contentStream, PreceptorAvatar, preceptorNameText } = props || {};
    return (
        <div className={`messengerCt__wrapper`}>
            <div className="messengerCt__message messengerCt__message--in">
                <div className="messengerCt__message-pic">
                    <img
                        src={PreceptorAvatar}
                        alt={preceptorNameText}
                    />
                </div>
                <div className="messengerCt__message-body">
                    <div className={`messengerCt__message-content --arrow-left`}>
                        <div className="messengerCt__message-username mt-4">
                            <div className='role-chat'>{`${preceptorNameText || "Instructor"}:`}</div>
                        </div>
                        <div className="messengerCt__message-text">
                            {contentStream && (
                                <div className="whiteSpace-break" dangerouslySetInnerHTML={{ __html: contentStream }} />
                            )}
                            <div className="typing-loader ml-2 mt-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoadingMessage;